import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=52d0c6e4&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Index.vue?vue&type=style&index=1&id=52d0c6e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d0c6e4",
  null
  
)

export default component.exports